import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { getReifegradSegmentColor } from "../../../utils/colors/scoreColor";
import { colors } from "../../../styles/colors";

export interface ReifegradDomain {
  key: string;
  label: string;
  value: number | null;
  status: string | null;
  weight: number;
}

interface ReifegradBreakdownProps {
  domains: ReifegradDomain[];
}

/**
 * Tooltip-Inhalt für den Reifegrad-Chip: Segmentbalken (Breite = Gewichtung
 * je Domäne, Farbe = Ampel-Status) plus Legende mit Domänenname und
 * aktuellem Unterstatus. Domänen ohne Wert (noch nicht erfasst/relevant)
 * werden grau dargestellt statt weggelassen, damit der Balken über alle
 * Projektzeilen hinweg vergleichbar bleibt.
 */
const ReifegradBreakdown: React.FC<ReifegradBreakdownProps> = ({ domains }) => {
  const totalWeight = domains.reduce((sum, d) => sum + d.weight, 0) || 1;

  return (
    <Box sx={{ minWidth: 220 }}>
      <Box
        sx={{
          display: "flex",
          height: 8,
          borderRadius: 1,
          overflow: "hidden",
          mb: 1,
        }}
      >
        {domains.map((domain) => (
          <Box
            key={domain.key}
            sx={{
              flexGrow: domain.weight / totalWeight,
              flexBasis: 0,
              backgroundColor: getReifegradSegmentColor(domain.value),
            }}
          />
        ))}
      </Box>
      <Stack spacing={0.5}>
        {domains.map((domain) => (
          <Box
            key={domain.key}
            sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                flexShrink: 0,
                backgroundColor: getReifegradSegmentColor(domain.value),
              }}
            />
            <Typography
              variant="caption"
              sx={{ color: colors.tooltip.heading, fontWeight: 600 }}
            >
              {domain.label}:
            </Typography>
            <Typography variant="caption" sx={{ color: colors.tooltip.text }}>
              {domain.status ?? "Noch nicht erfasst"}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default ReifegradBreakdown;
